/** Mirrors the backend's isPerilValueIncluded — a peril option value is "active" when it is
 *  not undefined, null, false, 'false', '0', 0, or empty string. */
export const isPerilValueIncluded = (val: unknown): boolean =>
  val !== undefined &&
  val !== null &&
  val !== false &&
  val !== 'false' &&
  val !== '0' &&
  val !== 0 &&
  val !== '';
